/**
 * Cupones Receta Solidaria — extraído de main-cart-items.liquid (límite 256 KB Shopify).
 * Requiere: axios, SweetAlert2, Bootstrap Modal (opcional).
 */
(function () {
  function farmexSwalFire(options) {
    if (typeof Swal === 'undefined') return Promise.resolve();
    return Swal.fire(
      Object.assign(
        {
          target: document.body,
          heightAuto: false
        },
        options || {}
      )
    );
  }

  window.productosRecetaSolidaria = window.productosRecetaSolidaria || [];
  window.cuponesRecetaSolidariaMap = window.cuponesRecetaSolidariaMap || {};
  window.cuponesRecetaSolidariaEstado = window.cuponesRecetaSolidariaEstado || {};
  window.skusRecetaSolidariaExcluidos = window.skusRecetaSolidariaExcluidos || {};

  // true = API local (ngrok/Laravel) | false = https://services.farmex.cl
  const RS_USAR_API_LOCAL = false;
  const FARMEX_API_BASE = 'https://services.farmex.cl';
  const NGROK_API_BASE = 'https://1b22-190-215-90-239.ngrok-free.app';

  function getRsApiBase() {
    return (RS_USAR_API_LOCAL ? NGROK_API_BASE : FARMEX_API_BASE).replace(/\/$/, '');
  }

  function esCampaniaRecetaSolidaria(campania) {
    const c = String(campania || '')
      .toLowerCase()
      .replace(/\s+/g, '')
      .trim();
    return c === 'recetasolidaria' || c === 'accedealprogramarecetasolidariadeabbott';
  }

  function getRsApiHeaders() {
    const headers = {};
    if (getRsApiBase().indexOf('ngrok') !== -1) {
      headers['ngrok-skip-browser-warning'] = 'true';
    }
    return headers;
  }

  function getRsValidarCuponUrl() {
    return getRsApiBase() + '/api/validar-cupon-rs';
  }

  function escapeHtmlRs(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getEstadoCuponRs(sku) {
    const excluidos = window.skusRecetaSolidariaExcluidos || {};
    if (excluidos[sku]) return 'excluido';
    const estados = window.cuponesRecetaSolidariaEstado || {};
    return estados[sku]?.estado || 'pendiente';
  }

  function getProductosRecetaSolidariaActivos() {
    const excluidos = window.skusRecetaSolidariaExcluidos || {};
    return (window.productosRecetaSolidaria || []).filter((p) => !excluidos[p.sku]);
  }

  function todosCuponesRsCompletosYValidos() {
    const productosActivos = getProductosRecetaSolidariaActivos();
    if (productosActivos.length === 0) return false;
    const map = window.cuponesRecetaSolidariaMap || {};
    const estados = window.cuponesRecetaSolidariaEstado || {};
    return productosActivos.every((p) => {
      const sku = p.sku;
      return estados[sku]?.estado === 'valid' && !!map[sku];
    });
  }

  function estaBeneficioRecetaSolidariaSeleccionado() {
    const rsCheckbox =
      document.getElementById('RecetaSolidaria') ||
      document.querySelector('.radioModalBeneficios[value="RecetaSolidaria"]');
    return !!(rsCheckbox && rsCheckbox.checked);
  }

  async function intentarAplicarConvenioTrasValidarCuponesRs() {
    if (!todosCuponesRsCompletosYValidos() || !estaBeneficioRecetaSolidariaSeleccionado()) {
      return false;
    }
    if (typeof btnAceptarBeneficio_Click === 'function') {
      await btnAceptarBeneficio_Click();
      return true;
    }
    const btnAplicar = document.getElementById('btnAceptarBeneficio');
    if (btnAplicar) {
      btnAplicar.click();
      return true;
    }
    return false;
  }

  function getResumenCuponesRs() {
    const productos = window.productosRecetaSolidaria || [];
    const excluidos = window.skusRecetaSolidariaExcluidos || {};
    const estados = window.cuponesRecetaSolidariaEstado || {};
    const activos = productos.filter((p) => !excluidos[p.sku]);
    let validos = 0;
    let invalidos = 0;
    let pendientes = 0;

    activos.forEach((p) => {
      const estado = estados[p.sku]?.estado || 'pendiente';
      if (estado === 'valid') validos++;
      else if (estado === 'invalid') invalidos++;
      else pendientes++;
    });

    return {
      total: productos.length,
      activos: activos.length,
      excluidos: productos.length - activos.length,
      validos,
      invalidos,
      pendientes,
      completos: activos.length > 0 && validos === activos.length && invalidos === 0
    };
  }

  function actualizarPasosCuponesRs(resumen) {
    const steps = document.querySelectorAll('#modalCuponesRecetaSolidaria .rs-cupones-step');
    if (!steps.length) return;

    const r = resumen || getResumenCuponesRs();
    let pasoActivo = 1;
    if (r.validos > 0 || r.invalidos > 0) pasoActivo = 2;
    if (r.completos) pasoActivo = 3;

    steps.forEach((step) => {
      const n = parseInt(step.getAttribute('data-rs-step'), 10);
      step.classList.remove('rs-cupones-step--active', 'rs-cupones-step--done');
      if (n < pasoActivo) step.classList.add('rs-cupones-step--done');
      else if (n === pasoActivo) step.classList.add('rs-cupones-step--active');
    });
  }

  function actualizarProgresoCuponesRs() {
    const resumen = getResumenCuponesRs();
    const wrap = document.getElementById('rsCuponesProgressWrap');
    const label = document.getElementById('rsCuponesProgressLabel');
    const count = document.getElementById('rsCuponesProgressCount');
    const bar = document.getElementById('rsCuponesProgressBar');
    const fill = document.getElementById('rsCuponesProgressFill');
    const hint = document.getElementById('rsCuponesFooterHint');
    const btnGuardar = document.getElementById('btnGuardarCuponesRS');

    if (wrap) {
      wrap.hidden = resumen.activos === 0;
    }

    const pct = resumen.activos > 0 ? Math.round((resumen.validos / resumen.activos) * 100) : 0;

    if (count) {
      count.textContent = resumen.validos + ' de ' + resumen.activos + ' validados';
    }
    if (label) {
      if (resumen.completos) {
        label.textContent = '¡Listo para aplicar convenio!';
      } else if (resumen.invalidos > 0) {
        label.textContent = 'Revisa los cupones con error';
      } else {
        label.textContent = 'Progreso de validación';
      }
    }
    if (fill) {
      fill.style.width = pct + '%';
      fill.classList.toggle('rs-progress-complete', resumen.completos);
    }
    if (bar) {
      bar.setAttribute('aria-valuenow', String(pct));
      bar.setAttribute('aria-valuemax', '100');
    }

    if (hint) {
      hint.classList.remove('rs-hint-success', 'rs-hint-warning');
      if (resumen.completos) {
        hint.textContent = 'Todos los cupones están validados. Al confirmar se aplicará el convenio automáticamente.';
        hint.classList.add('rs-hint-success');
      } else if (resumen.invalidos > 0) {
        hint.textContent = 'Corrige los cupones inválidos o marca el producto como «sin descuento RS».';
        hint.classList.add('rs-hint-warning');
      } else if (resumen.pendientes > 0) {
        hint.textContent = 'Ingresa el cupón de cada producto y presiona «Validar cupones».';
      } else {
        hint.textContent = '';
      }
    }

    if (btnGuardar) {
      btnGuardar.classList.toggle('rs-btn-ready', resumen.completos);
      if (resumen.completos) {
        btnGuardar.textContent = btnGuardar.dataset.rsLabelOriginal
          ? 'Validar y aplicar convenio'
          : (btnGuardar.textContent.includes('Validando') ? btnGuardar.textContent : 'Validar y aplicar convenio');
      } else if (!btnGuardar.disabled) {
        btnGuardar.textContent = btnGuardar.dataset.rsLabelOriginal || 'Validar cupones';
      }
    }

    actualizarPasosCuponesRs(resumen);
    actualizarEstadoCuponesRsEnCarrito(resumen);
    return resumen;
  }

  function actualizarEstadoCuponesRsEnCarrito(resumen) {
    const r = resumen || getResumenCuponesRs();
    const badge = document.getElementById('rsBtnCuponesBadge');
    const hint = document.getElementById('rsBeneficioHint');
    const btn = document.getElementById('btnVerCuponesRS');

    if (badge) {
      if (r.activos === 0) {
        badge.hidden = true;
      } else if (r.completos) {
        badge.hidden = false;
        badge.textContent = 'Listo';
        badge.className = 'rs-btn-rs-badge rs-badge-complete';
      } else if (r.validos > 0) {
        badge.hidden = false;
        badge.textContent = r.validos + '/' + r.activos;
        badge.className = 'rs-btn-rs-badge rs-badge-partial';
      } else {
        badge.hidden = false;
        badge.textContent = r.activos + ' prod.';
        badge.className = 'rs-btn-rs-badge';
      }
    }

    if (hint) {
      hint.classList.remove('rs-hint-ok', 'rs-hint-pending');
      if (r.completos) {
        hint.textContent = 'Cupones validados. Usa «Validar cupones» para aplicar el descuento.';
        hint.classList.add('rs-hint-ok');
      } else if (r.activos > 0) {
        hint.textContent = r.validos + ' de ' + r.activos + ' cupones validados.';
        if (r.validos < r.activos) hint.classList.add('rs-hint-pending');
      } else {
        hint.textContent = '';
      }
    }

    if (btn && r.completos) {
      btn.classList.add('rs-btn-complete');
    } else if (btn) {
      btn.classList.remove('rs-btn-complete');
    }
  }

  function syncHiddenCuponRecetaSolidaria() {
    const hidden = document.getElementById('cInput1');
    if (hidden) hidden.value = getCuponRecetaSolidariaEnvio() || '';
  }

  function interpretarRespuestaValidarCuponRs(data) {
    const payload = data || {};
    if (payload.valid === true) {
      return { valido: true, mensaje: payload.message || 'Cupón válido para este producto' };
    }
    return {
      valido: false,
      mensaje: payload.message || payload.error || 'Cupón no válido para este producto'
    };
  }

  async function validarCuponRecetaSolidariaAPI(cupon, sku) {
    const cuponLimpio = String(cupon || '').trim();
    const skuLimpio = String(sku || '').trim();
    if (!cuponLimpio || !skuLimpio) {
      return { valido: false, mensaje: 'Cupón y producto son requeridos' };
    }

    try {
      const response = await axios.get(getRsValidarCuponUrl(), {
        params: { cupon: cuponLimpio, sku: skuLimpio },
        headers: getRsApiHeaders()
      });
      return interpretarRespuestaValidarCuponRs(response.data);
    } catch (error) {
      console.error('Error validando cupón RS:', error);
      if (error.response?.data) {
        return interpretarRespuestaValidarCuponRs(error.response.data);
      }
      return {
        valido: false,
        mensaje: 'No se pudo validar el cupón. Intenta nuevamente.'
      };
    }
  }

  function renderTablaCuponesRS() {
    const contenedor = document.getElementById('rsCuponesTablaContenedor');
    if (!contenedor) return;

    const productos = window.productosRecetaSolidaria || [];
    if (productos.length === 0) {
      contenedor.innerHTML = '<p class="rs-cupones-empty">No hay productos de Receta Solidaria en tu carrito.</p>';
      actualizarProgresoCuponesRs();
      return;
    }

    const cuponesMap = window.cuponesRecetaSolidariaMap || {};
    const estados = window.cuponesRecetaSolidariaEstado || {};
    const excluidos = window.skusRecetaSolidariaExcluidos || {};
    let cards = '';

    productos.forEach((p) => {
      const skuRaw = p.sku;
      const sku = escapeHtmlRs(skuRaw);
      const titulo = escapeHtmlRs(p.title);
      const estado = getEstadoCuponRs(skuRaw);
      const cuponVal = escapeHtmlRs(cuponesMap[skuRaw] || '');
      const excluido = !!excluidos[skuRaw];

      let inputClass = 'cupon-rs-input';
      let cardMod = '';
      let estadoHtml = '<span class="rs-cupon-estado rs-cupon-estado-pendiente">Pendiente</span>';
      let accionHtml = '';

      if (estado === 'valid') {
        inputClass += ' rs-cupon-valid';
        cardMod = ' rs-cupon-card--valid';
        estadoHtml = '<span class="rs-cupon-estado rs-cupon-estado-valid">✓ Válido</span>';
      } else if (estado === 'invalid') {
        inputClass += ' rs-cupon-invalid';
        cardMod = ' rs-cupon-card--invalid';
        const msg = escapeHtmlRs(estados[skuRaw]?.mensaje || 'Cupón inválido');
        estadoHtml = '<span class="rs-cupon-estado rs-cupon-estado-invalid">✗ ' + msg + '</span>';
      } else if (estado === 'excluido') {
        inputClass += ' rs-cupon-excluido';
        cardMod = ' rs-cupon-card--excluido';
        estadoHtml = '<span class="rs-cupon-estado rs-cupon-estado-excluido">Sin descuento</span>';
        accionHtml =
          '<button type="button" class="rs-cupon-btn-incluir" data-rs-incluir data-sku="' +
          sku +
          '">Volver a aplicar RS</button>';
      }

      if (estado !== 'excluido') {
        accionHtml =
          '<button type="button" class="rs-cupon-btn-excluir" data-rs-excluir data-sku="' +
          sku +
          '">No aplicar descuento</button>';
      }

      const inputDisabled = excluido ? ' disabled' : '';
      cards +=
        '<article class="rs-cupon-card' +
        cardMod +
        '" data-rs-sku="' +
        sku +
        '">' +
        '<div class="rs-cupon-card__header">' +
        '<h6 class="rs-cupon-card__title">' +
        titulo +
        '</h6>' +
        estadoHtml +
        '</div>' +
        '<div class="rs-cupon-card__body">' +
        '<label class="rs-cupon-card__label" for="rs-cupon-' +
        sku +
        '">Código de cupón</label>' +
        '<input type="text" id="rs-cupon-' +
        sku +
        '" class="' +
        inputClass +
        '" data-sku="' +
        sku +
        '" placeholder="Ej: ABC123" value="' +
        cuponVal +
        '" autocomplete="off"' +
        inputDisabled +
        ' />' +
        '</div>' +
        '<div class="rs-cupon-card__footer">' +
        accionHtml +
        '</div>' +
        '</article>';
    });

    contenedor.innerHTML = '<div class="rs-cupones-list">' + cards + '</div>';
    actualizarProgresoCuponesRs();
  }

  window.excluirProductoRecetaSolidaria = function excluirProductoRecetaSolidaria(sku) {
    if (!sku) return;
    window.skusRecetaSolidariaExcluidos = window.skusRecetaSolidariaExcluidos || {};
    window.skusRecetaSolidariaExcluidos[sku] = true;
    const map = { ...(window.cuponesRecetaSolidariaMap || {}) };
    delete map[sku];
    window.cuponesRecetaSolidariaMap = map;
    window.cuponesRecetaSolidariaEstado = window.cuponesRecetaSolidariaEstado || {};
    window.cuponesRecetaSolidariaEstado[sku] = { estado: 'excluido', mensaje: 'Sin descuento de Receta Solidaria' };
    syncHiddenCuponRecetaSolidaria();
    renderTablaCuponesRS();
  };

  window.incluirProductoRecetaSolidaria = function incluirProductoRecetaSolidaria(sku) {
    if (!sku) return;
    const excluidos = { ...(window.skusRecetaSolidariaExcluidos || {}) };
    delete excluidos[sku];
    window.skusRecetaSolidariaExcluidos = excluidos;
    const estados = { ...(window.cuponesRecetaSolidariaEstado || {}) };
    delete estados[sku];
    window.cuponesRecetaSolidariaEstado = estados;
    renderTablaCuponesRS();
  };

  function setRsCuponesLoading(activo) {
    const overlay = document.getElementById('rsCuponesLoadingOverlay');
    const modalEl = document.getElementById('modalCuponesRecetaSolidaria');
    const btnGuardar = document.getElementById('btnGuardarCuponesRS');
    const btnCancelar =
      document.getElementById('btnCancelarCuponesRS') ||
      document.querySelector('#modalCuponesRecetaSolidaria .rs-cupones-btn-cancelar');

    if (overlay) overlay.hidden = !activo;
    if (modalEl) modalEl.setAttribute('aria-busy', activo ? 'true' : 'false');

    if (btnGuardar) {
      if (activo) {
        if (!btnGuardar.dataset.rsLabelOriginal) {
          btnGuardar.dataset.rsLabelOriginal = btnGuardar.textContent.trim();
        }
        btnGuardar.disabled = true;
        btnGuardar.innerHTML = '<span class="rs-btn-spinner" aria-hidden="true"></span> Validando…';
      } else {
        btnGuardar.disabled = false;
        btnGuardar.textContent = btnGuardar.dataset.rsLabelOriginal || 'Validar cupones';
      }
    }
    if (btnCancelar) btnCancelar.disabled = !!activo;
  }

  window.abrirModalCuponesRS = function abrirModalCuponesRS() {
    renderTablaCuponesRS();
    const btnGuardar = document.getElementById('btnGuardarCuponesRS');
    if (btnGuardar && !btnGuardar.dataset.rsLabelOriginal) {
      btnGuardar.dataset.rsLabelOriginal = 'Validar cupones';
    }
    const modalEl = document.getElementById('modalCuponesRecetaSolidaria');
    if (!modalEl) return;
    if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
      bootstrap.Modal.getOrCreateInstance(modalEl, { backdrop: 'static', keyboard: false }).show();
    } else {
      modalEl.style.display = 'block';
      modalEl.classList.add('show');
    }
  };

  async function guardarYValidarCuponesRecetaSolidaria() {
    const inputs = document.querySelectorAll('#modalCuponesRecetaSolidaria .cupon-rs-input');
    const excluidos = window.skusRecetaSolidariaExcluidos || {};
    const estados = { ...(window.cuponesRecetaSolidariaEstado || {}) };
    const map = {};
    let validos = 0;
    let invalidos = 0;
    let vacios = 0;

    setRsCuponesLoading(true);

    try {
      for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        const sku = input.getAttribute('data-sku');
        if (!sku || excluidos[sku]) continue;

        const valor = (input.value || '').trim();
        if (!valor) {
          delete estados[sku];
          vacios++;
          continue;
        }

        const resultado = await validarCuponRecetaSolidariaAPI(valor, sku);
        if (resultado.valido) {
          estados[sku] = { estado: 'valid', mensaje: resultado.mensaje };
          map[sku] = valor;
          validos++;
        } else {
          estados[sku] = { estado: 'invalid', mensaje: resultado.mensaje };
          invalidos++;
        }
      }

      window.cuponesRecetaSolidariaEstado = estados;
      window.cuponesRecetaSolidariaMap = map;
      syncHiddenCuponRecetaSolidaria();
      renderTablaCuponesRS();

      return {
        validos,
        invalidos,
        vacios,
        cerrarModal: invalidos === 0,
        todosCompletos: invalidos === 0 && todosCuponesRsCompletosYValidos()
      };
    } finally {
      setRsCuponesLoading(false);
    }
  }

  function getCuponRecetaSolidariaEnvio() {
    const map = window.cuponesRecetaSolidariaMap || {};
    const excluidos = window.skusRecetaSolidariaExcluidos || {};
    const valores = Object.entries(map)
      .filter(([sku]) => !excluidos[sku])
      .map(([, v]) => String(v || '').trim())
      .filter(Boolean);
    return valores.length ? valores.join(',') : null;
  }

  /** Cupones ya aplicados en la URL del carrito (otros convenios / descuentos manuales). */
  function obtenerCodigosDescuentoExistentes(cart, codigosAdicionales) {
    const codes = new Set();
    const fromUrl = new URLSearchParams(window.location.search).get('discount');
    if (fromUrl) {
      fromUrl.split(',').forEach((c) => {
        const t = String(c || '').trim();
        if (t) codes.add(t);
      });
    }
    const att = cart?.attributes || {};
    [att.discount_codes, att.discount, att.cupon].forEach((val) => {
      if (!val) return;
      String(val)
        .split(',')
        .forEach((c) => {
          const t = c.trim();
          if (t) codes.add(t);
        });
    });
    (codigosAdicionales || []).forEach((c) => {
      const t = String(c || '').trim();
      if (t) codes.add(t);
    });
    return Array.from(codes);
  }

  function unirCodigosDescuento(existentes, nuevos) {
    const merged = new Set();
    (existentes || []).forEach((c) => {
      const t = String(c || '').trim();
      if (t) merged.add(t);
    });
    const listaNuevos = Array.isArray(nuevos)
      ? nuevos
      : String(nuevos || '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean);
    listaNuevos.forEach((c) => merged.add(c));
    return Array.from(merged);
  }

  function getRsCrearCuponesShopifyUrl() {
    return getRsApiBase() + '/api/receta-solidaria/crear-cupones-shopify';
  }

  /**
   * Payload alineado con ConveniosController::crearCuponesShopifyRecetaSolidaria
   */
  function buildPayloadCrearCuponesShopify(cart, rut, codigosDescuentoExistentes) {
    const cuponesMap = window.cuponesRecetaSolidariaMap || {};
    const excluidos = window.skusRecetaSolidariaExcluidos || {};
    const productos = [];
    const skusCarro = [];

    (cart?.items || []).forEach((item) => {
      const skuItem = String(item.sku || '').trim();
      if (skuItem) skusCarro.push(skuItem);
      const sku = String(item.sku || '').trim();
      if (!sku || excluidos[sku]) return;

      const cupon = String(cuponesMap[sku] || '').trim();
      if (!cupon) return;

      productos.push({
        sku: sku,
        cupon: cupon,
        qty: item.quantity,
        cantidad: item.quantity,
        id_producto: item.product_id,
        id_variante: item.variant_id,
        variantid: item.variant_id,
        nombreProducto: item.product_title || item.title || ''
      });
    });

    const existentes = codigosDescuentoExistentes || obtenerCodigosDescuentoExistentes(cart, []);

    const payload = {
      rut: rut || localStorage.getItem('RUT') || '',
      cart_token: cart?.token || '',
      campaniaBeneficio: 'RecetaSolidaria',
      campania: 'Receta Solidaria',
      productos: productos,
      skus_carro: skusCarro,
      cupones_por_sku: cuponesMap,
      cuponesRecetaSolidariaMap: cuponesMap,
      skus_precio_normal: excluidos,
      discount_codes_existentes: existentes.join(','),
      crear_en_shopify: true
    };

    const urlRecetas = localStorage.getItem('Tus recetas:');
    if (urlRecetas && urlRecetas !== '[]') {
      payload.url_recetas = urlRecetas;
    }

    return payload;
  }

  /**
   * Arma /cart/{variants}?campaign=...&discount=... tras crear cupones en Shopify.
   */
  function buildCartUrlRecetaSolidaria(cart, cuponesRs, discountUrlParam, codigosDescuentoExistentes) {
    const porSku = {};
    (cuponesRs || []).forEach((c) => {
      if (c && c.sku) porSku[String(c.sku).trim()] = c;
    });

    const partes = [];
    (cart?.items || []).forEach((item) => {
      const sku = String(item.sku || '').trim();
      const info = porSku[sku];
      // Precio de tienda (variante del carrito); el descuento lo aplica ?discount=
      const variantId = item.variant_id || info?.shopify_variant_id;
      const qty = item.quantity || 1;
      if (variantId) {
        partes.push(String(variantId) + ':' + String(qty));
      }
    });

    if (partes.length === 0) return '';

    const todosLosCodigos = unirCodigosDescuento(
      codigosDescuentoExistentes || obtenerCodigosDescuentoExistentes(cart, []),
      discountUrlParam
    );

    let url = '/cart/' + partes.join(',');
    url += '?campaign=' + encodeURIComponent('Receta Solidaria');
    url += '&storefront=true';
    if (todosLosCodigos.length > 0) {
      url += '&discount=' + encodeURIComponent(todosLosCodigos.join(','));
    }
    return url;
  }

  function formatearErroresRs(errors) {
    if (!errors || !errors.length) return '';
    return errors
      .map((e) => {
        const sku = e.sku ? 'SKU ' + e.sku + ': ' : '';
        return sku + (e.message || 'Error desconocido');
      })
      .join('\n');
  }

  function esErrorCuponYaUsado(errors, body) {
    if (body && body.solo_cupones_usados === true) return true;
    if (!errors || !errors.length) return false;
    return errors.every((e) => e.reason === 'cupon_ya_usado');
  }

  function tituloErrorRs(errors, body) {
    if (esErrorCuponYaUsado(errors, body)) return 'Cupón ya utilizado';
    return 'No se pudo aplicar Receta Solidaria';
  }

  function mensajePrincipalRs(body, errors) {
    if (body && body.message) return body.message;
    return formatearErroresRs(errors) || 'Intenta nuevamente.';
  }

  /**
   * Camino D — POST /api/receta-solidaria/crear-cupones-shopify (ConveniosController)
   */
  async function crearCuponesRecetaSolidariaShopify({ rut, cart, codigosDescuentoExistentes }) {
    const existentes = codigosDescuentoExistentes || obtenerCodigosDescuentoExistentes(cart, []);
    const payload = buildPayloadCrearCuponesShopify(cart, rut, existentes);
    const url = getRsCrearCuponesShopifyUrl();

    if (!payload.productos || payload.productos.length === 0) {
      return {
        success: false,
        message: 'Debes ingresar cupones válidos para al menos un producto de Receta Solidaria.'
      };
    }

    console.group('[Camino D] POST crear-cupones-shopify');
    console.log('URL:', url);
    console.log('Payload:', payload);
    console.groupEnd();

    try {
      const response = await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          ...getRsApiHeaders()
        }
      });

      const body = response.data || {};
      const cupones = body.cupones || [];
      const errors = body.errors || [];

      if (cupones.length === 0) {
        return {
          success: false,
          solo_cupones_usados: esErrorCuponYaUsado(errors, body),
          message: mensajePrincipalRs(body, errors) || 'No se pudo crear ningún cupón en Shopify.',
          errors: errors,
          data: body
        };
      }

      const cartUrl = buildCartUrlRecetaSolidaria(
        cart,
        cupones,
        body.discount_url_param || '',
        existentes
      );
      if (!cartUrl) {
        return {
          success: false,
          message: 'Cupones creados pero no se pudo armar la URL del carrito.',
          errors: errors,
          data: body
        };
      }

      localStorage.setItem('Campania', 'Receta Solidaria');
      localStorage.setItem('ClienteMetlife', 'No');
      localStorage.setItem('isCertificacion', 'false');

      const partial = errors.length > 0 || body.success === false;

      return {
        success: !partial,
        partial: partial,
        url: cartUrl,
        message: body.message || '',
        errors: errors,
        discount_url_param: body.discount_url_param,
        cupones: cupones,
        data: body
      };
    } catch (error) {
      console.error('[Camino D] crear-cupones-shopify:', error);
      const status = error.response?.status;
      const errBody = error.response?.data || {};
      const errors = errBody.errors || [];
      let message =
        errBody.message ||
        errBody.error ||
        formatearErroresRs(errors) ||
        'No se pudieron crear los cupones de Receta Solidaria.';

      if (status === 400 || status === 422) {
        message = errBody.message || formatearErroresRs(errors) || message;
      }

      return {
        success: false,
        solo_cupones_usados: esErrorCuponYaUsado(errors, errBody),
        message: message,
        status: status,
        errors: errors,
        data: errBody
      };
    }
  }

  /**
   * Camino D — aplica RS creando cupones en Shopify y redirige al carrito con ?discount=
   * @returns {Promise<boolean>} true si redirigió al carrito
   */
  async function aplicarConvenioRecetaSolidariaCaminoD(rut, cart, opciones) {
    if (typeof window.crearCuponesRecetaSolidariaShopify !== 'function') {
      if (typeof showAlert === 'function') {
        showAlert('error', 'No se cargó el módulo de Receta Solidaria. Recarga la página.');
      }
      return false;
    }

    const codigosExtra = (opciones && opciones.codigosDescuentoExistentes) || [];
    const resultadoRs = await window.crearCuponesRecetaSolidariaShopify({
      rut: rut,
      cart: cart,
      codigosDescuentoExistentes: codigosExtra
    });

    if (resultadoRs.url) {
      if (resultadoRs.partial && typeof Swal !== 'undefined') {
        const detalleErrores = (resultadoRs.errors || [])
          .map((e) => (e.sku ? e.sku + ': ' : '') + (e.message || ''))
          .filter(Boolean)
          .join('\n');
        await farmexSwalFire({
          title: 'Cupones aplicados con advertencias',
          text: (resultadoRs.message || '') + (detalleErrores ? '\n\n' + detalleErrores : ''),
          icon: 'warning',
          confirmButtonText: 'Continuar al carrito'
        });
      }
      if (typeof redireccionarCarroPrecargado === 'function') {
        redireccionarCarroPrecargado(resultadoRs.url);
      } else {
        window.location.href = resultadoRs.url;
      }
      return true;
    }

    const errores = resultadoRs.errors || resultadoRs.data?.errors || [];
    const icono = resultadoRs.solo_cupones_usados ? 'warning' : 'error';

    if (typeof Swal !== 'undefined') {
      await farmexSwalFire({
        title: tituloErrorRs(errores, resultadoRs.data),
        text: mensajePrincipalRs(resultadoRs.data, errores) || resultadoRs.message || 'Intenta nuevamente.',
        icon: icono,
        confirmButtonText: 'OK'
      });
    } else if (typeof showAlert === 'function') {
      showAlert(icono === 'warning' ? 'warn' : 'error', resultadoRs.message || 'No se pudo aplicar Receta Solidaria.');
    }
    return false;
  }

  window.getRsApiBase = getRsApiBase;
  window.esCampaniaRecetaSolidaria = esCampaniaRecetaSolidaria;
  window.getRsCrearCuponesShopifyUrl = getRsCrearCuponesShopifyUrl;
  window.buildPayloadCrearCuponesShopify = buildPayloadCrearCuponesShopify;
  window.crearCuponesRecetaSolidariaShopify = crearCuponesRecetaSolidariaShopify;
  window.aplicarConvenioRecetaSolidariaCaminoD = aplicarConvenioRecetaSolidariaCaminoD;
  window.getCuponRecetaSolidariaEnvio = getCuponRecetaSolidariaEnvio;
  window.obtenerCodigosDescuentoExistentes = obtenerCodigosDescuentoExistentes;
  window.getProductosRecetaSolidariaActivos = getProductosRecetaSolidariaActivos;
  window.todosCuponesRsCompletosYValidos = todosCuponesRsCompletosYValidos;
  window.intentarAplicarConvenioTrasValidarCuponesRs = intentarAplicarConvenioTrasValidarCuponesRs;
  window.actualizarEstadoCuponesRsEnCarrito = actualizarEstadoCuponesRsEnCarrito;
  window.actualizarProgresoCuponesRs = actualizarProgresoCuponesRs;
  window.guardarYValidarCuponesRecetaSolidaria = guardarYValidarCuponesRecetaSolidaria;

  document.addEventListener('DOMContentLoaded', function () {
    const rsCuponesContenedor = document.getElementById('rsCuponesTablaContenedor');
    if (rsCuponesContenedor) {
      rsCuponesContenedor.addEventListener('click', (e) => {
        const btnExcluir = e.target.closest('[data-rs-excluir]');
        const btnIncluir = e.target.closest('[data-rs-incluir]');
        if (btnExcluir) {
          window.excluirProductoRecetaSolidaria(btnExcluir.getAttribute('data-sku'));
        }
        if (btnIncluir) {
          window.incluirProductoRecetaSolidaria(btnIncluir.getAttribute('data-sku'));
        }
      });
      rsCuponesContenedor.addEventListener('input', (e) => {
        if (!e.target.matches('.cupon-rs-input')) return;
        const sku = e.target.getAttribute('data-sku');
        if (!sku || !window.cuponesRecetaSolidariaEstado) return;
        delete window.cuponesRecetaSolidariaEstado[sku];
        e.target.classList.remove('rs-cupon-valid', 'rs-cupon-invalid');
        const card = e.target.closest('.rs-cupon-card');
        if (card) {
          card.classList.remove('rs-cupon-card--valid', 'rs-cupon-card--invalid');
        }
        actualizarProgresoCuponesRs();
      });

      rsCuponesContenedor.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' || !e.target.matches('.cupon-rs-input')) return;
        e.preventDefault();
        const btn = document.getElementById('btnGuardarCuponesRS');
        if (btn && !btn.disabled) btn.click();
      });
    }

    actualizarEstadoCuponesRsEnCarrito();

    const btnGuardarCuponesRS = document.getElementById('btnGuardarCuponesRS');
    if (btnGuardarCuponesRS) {
      if (!btnGuardarCuponesRS.dataset.rsLabelOriginal) {
        btnGuardarCuponesRS.dataset.rsLabelOriginal = 'Validar cupones';
      }

      btnGuardarCuponesRS.addEventListener('click', async function () {
        const resultado = await guardarYValidarCuponesRecetaSolidaria();

        if (resultado.todosCompletos) {
          const modalEl = document.getElementById('modalCuponesRecetaSolidaria');
          if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
            bootstrap.Modal.getOrCreateInstance(modalEl).hide();
          } else if (modalEl) {
            modalEl.style.display = 'none';
            modalEl.classList.remove('show');
          }
          await intentarAplicarConvenioTrasValidarCuponesRs();
          return;
        }

        let icon = 'success';
        let title = 'Cupones validados';
        let text = resultado.validos + ' cupón(es) válido(s).';

        if (resultado.invalidos > 0) {
          icon = 'warning';
          title = 'Revisa los cupones marcados en rojo';
          text = resultado.validos + ' válido(s), ' + resultado.invalidos + ' inválido(s).';
          if (resultado.vacios > 0) {
            text += ' ' + resultado.vacios + ' sin ingresar.';
          }
          text += ' Corrige los errores o marca el producto como «sin descuento RS».';
        } else if (resultado.validos === 0 && resultado.vacios > 0) {
          icon = 'info';
          title = 'Faltan cupones';
          text = 'Ingresa el cupón de cada producto antes de validar.';
        }

        await farmexSwalFire({ title: title, text: text, icon: icon, confirmButtonText: 'Entendido' });

        if (resultado.cerrarModal && resultado.validos > 0) {
          const modalEl = document.getElementById('modalCuponesRecetaSolidaria');
          if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
            bootstrap.Modal.getOrCreateInstance(modalEl).hide();
          } else if (modalEl) {
            modalEl.style.display = 'none';
            modalEl.classList.remove('show');
          }
        }
      });
    }
  });
})();
